export default __webpack_public_path__ + "static/media/glass-tempered.e3e0761e.jpg";